<template>
  <div class="jps-news jps-static">
    <BaseContainer tag="div" size="middle">
      <UiPageHeader
        class="title"
        :title="dapLangGlobal.news"
        icon="koicon/koicon-33"
      />
    </BaseContainer>

    <BaseContainer tag="div" size="middle">
      <div
        v-if="ss.searched"
        :id="ss.state.storeId"
       >
        <UiNewsList
          :data="ss.state.result.list"
        />

        <SearchPagination 
          class="footer-paginaition" 
          autoscroll
          :ss="ss"
        />
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { searchPage } = usePage()

const ss: SearchStore<Page> = useSearch<Page>(
  {},
  searchPage,
  {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'P'
      q.filter = { spaceType: ['NEWS'] }
      q.sort = ['date:desc']
      return q
    }
  }
)
await ss.restoreQuery()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.footer-paginaition {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>
